/* MoreLuxe — global storefront behaviour
   Vanilla re-implementation of the design's React interactions:
   thin-line Lucide icons, the mobile nav drawer, and shared accordions.
   Section-specific logic (calendar, reviews carousel, collection filter)
   lives inline in those sections. */
(function () {
  'use strict';

  function drawIcons() {
    if (window.lucide && typeof window.lucide.createIcons === 'function') {
      window.lucide.createIcons();
    }
  }

  /* ---- mobile nav drawer (drops down from beneath the sticky header) ----
     Non-modal: no dimming overlay, the rest of the page stays interactive.
     Open/close is a max-height accordion measured in JS, so the closed height
     is exactly 0 — it can never get "stuck" half-collapsed. */
  function drawerEl() { return document.querySelector('.nav-drawer'); }
  function drawerIsOpen() {
    var d = drawerEl();
    return !!(d && d.classList.contains('open'));
  }
  function anchorDrawer(drawer) {
    var header = document.querySelector('.hdr');
    if (drawer && header) {
      // emerge from directly under the (sticky) header bar, whatever its height
      drawer.style.top = Math.round(header.getBoundingClientRect().bottom) + 'px';
    }
  }
  function setDrawer(open) {
    var drawer = drawerEl();
    var burger = document.querySelector('.hdr-burger');
    if (!drawer) return;
    if (open) {
      anchorDrawer(drawer);                                  // sit directly under the pinned header
      drawer.style.maxHeight = drawer.scrollHeight + 'px';   // expand to content height
    } else {
      drawer.style.maxHeight = '0px';                        // collapse fully
    }
    drawer.classList.toggle('open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    // Keep the collapsed drawer out of the tab order + a11y tree entirely.
    // `inert` handles focus and screen readers; the CSS visibility rule is the
    // fallback for browsers without inert support.
    if (open) { drawer.removeAttribute('inert'); } else { drawer.setAttribute('inert', ''); }
    if (burger) {
      burger.classList.toggle('is-open', open);   // morphs the two bars into an X
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    }
  }

  /* Event delegation so behaviour survives Shopify theme-editor re-renders */
  document.addEventListener('click', function (e) {
    // the burger is the single toggle (and the X that closes it)
    if (e.target.closest('.hdr-burger')) { setDrawer(!drawerIsOpen()); return; }
    // tapping a menu link closes the panel (the link still navigates)
    if (e.target.closest('.nav-drawer-list a')) { setDrawer(false); return; }
    // tapping anywhere outside closes it WITHOUT swallowing that click,
    // so the rest of the page stays fully clickable
    if (drawerIsOpen() && !e.target.closest('.nav-drawer')) { setDrawer(false); }

    // NOTE: accordions are handled by each section's own scoped script
    // (e.g. the product page), to keep aria-expanded state in sync and
    // avoid a double-toggle from a second global handler.
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setDrawer(false);
  });

  // keep the dropdown anchored & sized if the viewport changes while open
  window.addEventListener('resize', function () {
    if (drawerIsOpen()) {
      var drawer = drawerEl();
      anchorDrawer(drawer);
      drawer.style.maxHeight = drawer.scrollHeight + 'px';
    }
  });

  function init() { drawIcons(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify theme editor: redraw icons whenever a section is (re)loaded */
  document.addEventListener('shopify:section:load', drawIcons);
  document.addEventListener('shopify:section:select', drawIcons);
})();


/* ---- Designers dropdown: tap-to-open on touch devices + aria-expanded sync ----
   Hover/focus-within handles mouse/keyboard (CSS). On coarse pointers the first
   tap opens the menu instead of navigating; a second tap follows the link.
   Any outside click closes it. */
(function () {
  function setExpanded(item, open) {
    item.classList.toggle('is-open', open);
    var t = item.querySelector('.nav-dd-trigger');
    if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function closeAll(except) {
    var open = document.querySelectorAll('.nav-item--dd.is-open');
    for (var i = 0; i < open.length; i++) if (open[i] !== except) setExpanded(open[i], false);
  }
  document.addEventListener('click', function (e) {
    var trig = e.target.closest ? e.target.closest('.nav-dd-trigger') : null;
    if (trig && window.matchMedia('(pointer: coarse)').matches) {
      var item = trig.closest('.nav-item--dd');
      if (item && !item.classList.contains('is-open')) {
        e.preventDefault();
        closeAll(item);
        setExpanded(item, true);
        return;
      }
    }
    closeAll(trig ? trig.closest('.nav-item--dd') : null);
    if (!trig) closeAll(null);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
  // keep aria-expanded truthful for mouse/keyboard users too
  var items = document.querySelectorAll('.nav-item--dd');
  for (var i = 0; i < items.length; i++) (function (item) {
    item.addEventListener('mouseenter', function () { setExpanded(item, true); });
    item.addEventListener('mouseleave', function () { setExpanded(item, false); });
    item.addEventListener('focusin', function () { setExpanded(item, true); });
    item.addEventListener('focusout', function () { if (!item.contains(document.activeElement)) setExpanded(item, false); });
  })(items[i]);
})();
